import { navigateAction } from 'fluxible-router';
import { getSpotIdInjectorValue } from '@spotim/fed-common';
import me from '@spotim/fed-resources/resources/me';
import config from 'config/config';
import { getNetwork, getSpotId, setAccessToken, setToken } from 'app/scripts/services/app-state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { resolveContext } from '../../services/context-provider';
import { removeLoadingIndicator, addLoadingSpinner } from './add-loading-spinner';

const tokenErrors = [
  'SpotTokenIsMissingError',
  'SpotTokenNotFoundError',
  'SpotTokenExpiredError',
  'SpotTokenRevokedError',
  'SpotTokenSuspendedError',
  'SpotTokenCorruptedError'
];
const userErrors = [
  'UserIsNotSpotModeratorError',
  'UserIsNotSpotOwnerError',
  'HostPanelGetSpotFolderMessages_UserNotSpotOwnerOrModeratorError'
];

const mfaErrors = [
  'UserNonVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError',
  'UserVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError',
  'UserNonVerifiedPhone_UserNeedsToSendConfirmationCodeError',
  'UserVerifiedPhone_UserNeedsToSendConfirmationCodeError',
  'SpotMFACodeSender_ModeratorPhoneIsAlreadyVerifiedError'
];

function isTokenError(response) {
  return tokenErrors.indexOf(response.body.type) > -1;
}

function isUserError(response) {
  return userErrors.indexOf(response.body.type) > -1;
}

function isMFAError(response) {
  return mfaErrors.indexOf(response.body.type) > -1;
}
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function retryLogin(network_id = getNetwork().id, spotId = getSpotId()) {
  let i;
  // addLoadingSpinner();
  for (i = 0; i < 3; i++) {
    await sleep(1000);
    let res = await me.fetchNetworkToken(network_id);
    setToken(res.body.token);
    let {
      body: { roles }
    } = await me.getRoles();
    if (
      (roles && roles.owner && roles?.owner?.length > 0) ||
      (roles.moderator && roles?.moderator?.length > 0) ||
      (roles['moderation-viewer'] && roles['moderation-viewer']?.length > 0)
    ) {
      if (
        roles.owner?.findIndex(x => x === spotId) != -1 ||
        roles.moderator?.findIndex(x => x === spotId) != -1 ||
        roles['moderation-viewer']?.findIndex(x => x === spotId) != -1
      ) {
        removeLoadingIndicator();
        setToken(res.body.token);
        await setAccessToken();
        return true;
      }
    }
  }
  // removeLoadingIndicator();

  return false;
}

export function loginResponseInterceptor() {
  return async function responseInterceptor(request, response) {
    try {
      var url = config.api.login;
      var spotId = getSpotIdInjectorValue();
      if ((isTokenError(response) || isUserError(response)) && !!spotId) {
        ErrorNotifier.notifyError(Error(response.body.status));
        let {
          body: { network_name, network_id }
        } = await me.getNetworkIdBySpotId(spotId);
        const isAuthed = await retryLogin(network_id, spotId);
        if (!isAuthed) {
          url = `${config.api.basic}network/${network_name}`;
          window.location = url;
        } else {
          return;
        }
      } else if (isMFAError(response)) {
        switch (response.body.type) {
          case 'UserVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError':
          case 'SpotMFACodeSender_ModeratorPhoneIsAlreadyVerifiedError':
          case 'UserVerifiedPhone_UserNeedsToSendConfirmationCodeError':
          case 'UserNonVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError':
            resolveContext().then(context => {
              context.executeAction(navigateAction, {
                url: `/spot/${spotId}/two-factor-authentication`
              });
            });
            break;
          case 'UserNonVerifiedPhone_UserNeedsToSendConfirmationCodeError':
            resolveContext().then(context => {
              context.executeAction(navigateAction, {
                url: `/spot/${spotId}/two-factor-authentication`
              });
            });
            break;
        }
      } else {
        //throw new Error(response.body.status);
      }
    } catch (error) {
      ErrorNotifier.notifyError(error);
    }
    return { response };
  };
}
